<template>
  <span v-if="!shouldHidePriceUnit">
    <span v-if="priceDisplayArea">/{{ priceDisplayArea }}<sup>2</sup></span
    ><span v-if="priceDisplayInterval">/{{ priceDisplayInterval }}</span>
  </span>
</template>

<script lang="ts" setup>
import {
  AreaThePriceRefersTo,
  Buy,
  OfferType,
  PriceInterval,
  Rent,
} from '@smg-real-estate/hg-rets-schema';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineOptions({
  name: 'ListingPriceUnit',
});

const PRICE_AREA_LABELS = {
  [AreaThePriceRefersTo.All]: undefined,
  [AreaThePriceRefersTo.M2]: 'm',
  [AreaThePriceRefersTo.Km2]: 'km',
};

export interface Props {
  offerType: OfferType;
  listingPriceInfo?: Buy | Rent;
}
const props = withDefaults(defineProps<Props>(), {
  listingPriceInfo: undefined,
});

const area = computed<AreaThePriceRefersTo | undefined>(() => {
  return props.listingPriceInfo?.area;
});
const interval = computed<PriceInterval | undefined>(() => {
  return (props.listingPriceInfo as Rent)?.interval;
});
const shouldHidePriceUnit = computed<boolean>(() => {
  return (
    (props.offerType === OfferType.Rent && interval.value === PriceInterval.Month) ||
    (props.offerType === OfferType.Buy && area.value === AreaThePriceRefersTo.All)
  );
});
const priceDisplayArea = computed<string | undefined>(() => {
  return area.value ? PRICE_AREA_LABELS[area.value] : undefined;
});
const priceDisplayInterval = computed<string | undefined>(() => {
  if (props.offerType === OfferType.Buy) {
    return;
  }
  return interval.value ? (t(`priceInterval.${interval.value}`) as string) : undefined;
});
</script>
